import React from 'react';
import { Link } from 'react-router-dom';
import { AirVent, Box, WashingMachine, Tv, Droplets, Wrench, MapPin } from 'lucide-react';
import { services } from '../../data/services';
import { brands } from '../../data/brands';
import ActionButtons from '../shared/ActionButtons';
import LocationSelector from '../booking/LocationSelector';

interface ServiceTypesListProps {
  service?: Service;
  brandName?: string;
  location?: {
    state?: string;
    city?: string;
    area?: string;
  };
}

export default function ServicesList() {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Service Centers</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Expert repair service center for all your home appliances with same-day service and warranty
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const serviceUrl = `/services/${service.id}`;
            const serviceCenterUrl = `/services/${service.id}/service-center`;

            return (
              <div key={service.id} className="space-y-4">
                <Link
                  to={serviceUrl}
                  className="group relative bg-white p-6 rounded-xl shadow-sm hover:shadow-xl hover:bg-blue-600 transform hover:-translate-y-1 transition-all duration-300 block"
                >
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="p-4 bg-blue-50 rounded-full group-hover:bg-blue-500 transition-colors">
                      {getServiceIcon(service.icon)}
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 group-hover:text-white mb-2">
                        {service.name} Service Center
                      </h3>
                      <p className="text-gray-500 group-hover:text-blue-100 mb-4">
                        {service.description}
                      </p>
                      <span className="text-sm text-blue-600 group-hover:text-white font-medium">
                        Learn more →
                      </span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={serviceCenterUrl}
                  className="flex items-center justify-center px-4 py-2 bg-white border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all duration-200"
                >
                  <MapPin className="h-4 w-4 mr-2 text-blue-600" />
                  <span className="text-sm font-medium text-gray-700">Find Service Center</span>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function getServiceIcon(iconName: string) {
  const icons = {
    AirVent,
    Tv,
    WashingMachine,
    Box,
    Droplets,
    Wrench
  };
  const Icon = icons[iconName as keyof typeof icons] || Wrench;
  return <Icon className="h-12 w-12 text-blue-600 group-hover:text-white transition-colors" />;
}